import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import AuthGate from '../AuthGate/AuthGate';
import MarketPage from '../../pages/MarketPage';
import HomePage from '../../pages/HomePage';
import ProfilePage from '../../pages/ProfilePage';
import LegalInfoPage from '../../pages/LegalInfoPage';

export default function PageContainer({
  session,
  onResetAppState,
  onPWAInstallFromProfile,
  onPWASkipFromProfile,
  onOpenGame
}) {
  const location = useLocation();

  // Мемоизируем определение активной страницы
  const activePage = useMemo(() => {
    if (location.pathname === '/legal-info') return 'legal-info';
    if (location.pathname.startsWith('/marketplace')) return 'marketplace';
    if (location.pathname === '/home' || location.pathname.startsWith('/home/')) return 'home';
    if (location.pathname === '/profile') return 'profile';
    return 'home'; // по умолчанию
  }, [location.pathname]);

  // Мемоизируем компоненты страниц для предотвращения лишних перерендеров
  const marketplacePage = useMemo(() => (
    <AuthGate session={session}>
      <MarketPage onOpenGame={onOpenGame} />
    </AuthGate>
  ), [session, onOpenGame]);

  const homePage = useMemo(() => (
    <AuthGate session={session}>
      <HomePage onOpenGame={onOpenGame} />
    </AuthGate>
  ), [session, onOpenGame]);

  const profilePage = useMemo(() => (
    <AuthGate session={session}>
      <ProfilePage
        onResetAppState={onResetAppState}
        onPWAInstall={onPWAInstallFromProfile}
        onPWASkip={onPWASkipFromProfile}
      />
    </AuthGate>
  ), [session, onResetAppState, onPWAInstallFromProfile, onPWASkipFromProfile]);

  const legalInfoPage = useMemo(() => (
    <AuthGate session={session}>
      <LegalInfoPage />
    </AuthGate>
  ), [session]);

  return (
    <>
      {/* Все игры — доступен всем */}
      <div className="page-wrapper" style={{ display: activePage === 'marketplace' ? 'flex' : 'none' }}>
        {marketplacePage}
      </div>

      {/* Главная (Мои игры + Рекомендуем) — только для залогиненных */}
      <div className="page-wrapper" style={{ display: activePage === 'home' ? 'flex' : 'none' }}>
        {homePage}
      </div>

      {/* Профиль — только для залогиненных */}
      <div className="page-wrapper" style={{ display: activePage === 'profile' ? 'flex' : 'none' }}>
        {profilePage}
      </div>

      {/* Правовая информация — только для залогиненных */}
      <div className="page-wrapper" style={{ display: activePage === 'legal-info' ? 'flex' : 'none' }}>
        {legalInfoPage}
      </div>
    </>
  );
}
